const defaultState = {
  voucher_types: [],
  fetched: false,
  fetching: true,
}

export default (state = defaultState, action) => {
  switch(action.type) {
    case 'GET_VOUCHER_TYPES_PENDING': return {
      ...state,
      fetching: true,
      fetched: false,
    }
    case 'GET_VOUCHER_TYPES_FULFILLED': return {
      ...state,
      fetching: false,
      fetched: true,
      voucher_types: action.payload
    }

    default: return {...state}
  }
}


// WEBPACK FOOTER //
// ./src/reducers/voucherReducer.js